import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ICashOutRequest } from 'src/app/shared/interfaces/cashOutRequest';
import { ICashRequestInp } from 'src/app/shared/interfaces/cashRequestInp';
import { IFinancialTransaction } from 'src/app/shared/interfaces/financialTransaction';
import { ETransactionType } from 'src/app/shared/interfaces/transactionType-enum';
import { FakeDataService } from 'src/app/shared/mock/fake-data.service';
import { ModalComponent } from 'src/app/shared/modals/modal.component';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-user-wallet',
  templateUrl: './user-wallet.component.html',
  styleUrl: './user-wallet.component.css',
})

export class UserWalletComponent implements OnInit {

  
  wallet: number;
  transactionType = ETransactionType;
  transactionList: IFinancialTransaction[];
  requestList: ICashOutRequest[];
  cashReqInp: ICashRequestInp = {
    timeType: 2,
    price: 0
  }
  searchInp = {
    title: '',
    pageIndex: 0,
    pageSize: 0,
    status: null,
    type: null
  }
  transactionSearchInp = {
    title: '',
    pageIndex: 0,
    pageSize: 0,
    type: null
  }

  first: number = 0 ;
  rows: number = 10;
  pageSize = 10;  
  currentpage = 1;
  collectionSize: number = 10;
  collectionSize1: number = 10;
  first1: number = 0 ;
  rows1: number = 10;


  transactionStatus = [
    {title:'نا مشخص' , value:1},
    {title:'در حال بررسی' , value:2},
    {title:'انجام شده' , value:3},
    {title:'لغو شده' , value:4}
  ]

  @ViewChild('req') req!: ModalComponent;

  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
    private fakeDataService: FakeDataService
  ){}


  ngOnInit(): void {
    this.getWalletAmount();
    this.getRequestsList(0);
    this.getFinanceTransactions(0);
  }

  getWalletAmount() {
    this.apiService.apiCall('get', '/api/User/GetWalletAmount', ).subscribe((res: any) => {
      console.log(res);
      this.wallet = res.body.model;
    })
  }

  getFinanceTransactions(page) {
    this.transactionSearchInp = {
      title: this.searchInp.title,
      pageIndex: page+1,
      pageSize: this.pageSize,
      type: Number(this.searchInp.type)!=0?Number(this.searchInp.type):null
    }

    this.apiService.apiCall('post', '/api/User/GetTransactions', this.transactionSearchInp).subscribe((res: any) => {
      console.log(res);
      
      this.transactionList = res.body.model;
      this.collectionSize1 = res.body.collectionSize;
    })
  }

  getRequestsList(page) {
    this.searchInp = {
      title: this.searchInp.title,
      pageIndex: page+1,
      pageSize: this.pageSize,
      status: Number(this.searchInp.status)!=0?Number(this.searchInp.status):null,
      type: Number(this.searchInp.type)!=0?Number(this.searchInp.type):null
    }
    console.log(this.searchInp);
    
    this.apiService.apiCall('post', '/api/Doctor/GetAllDoctorCashOutRequest', this.searchInp).subscribe((res: any) => {
      console.log(res);
      
      this.requestList = res.body.model;
      this.collectionSize = res.body.collectionSize;
    })
  }

  sendRequest() {
    this.apiService.apiCall('post', '/api/Doctor/AddCashOutRequest', this.cashReqInp).subscribe((res: any) => {
      console.log(res);

      if (res.body.isSuccess == true) {
        this.messageService.add({severity: 'success', summary: 'موفق', detail: 'درخواست شما با موفقیت ثبت شد.' });
        this.req.close();
        
      } else {
        this.messageService.add({severity: 'error', summary: 'خطا', detail: res.body.message });
      }
    })
  }

}
